import Flex from '@Components/Bases/Flex';
import FormTextAreaAutoSize from '@Components/Form/FormTextAreaAutosize';
import { disabledTextAreaInputStyles } from '@Components/Form/styles';
import { InputLabel, Typography } from '@mui/material';

type StakeholderExpectationsProps = {
  isCompletedTh?: boolean;
  isCompletedEn?: boolean;
};

const StakeholderExpectations = ({
  isCompletedTh,
  isCompletedEn,
}: StakeholderExpectationsProps) => {
  return (
    <Flex flexDirection="column">
      <Typography fontWeight={'bold'} mb={2}>
        ความคาดหวังของผู้มีส่วนได้เสีย
      </Typography>
      <Flex>
        <InputLabel
          sx={{
            textAlign: 'right',
            marginRight: 2,
            width: '100%',
            height: 'fit-content',
            marginTop: '23px',
          }}
          required
        >
          ความคาดหวังของผู้มีส่วนได้เสีย
        </InputLabel>
        <Flex gap={1} minWidth={600}>
          <FormTextAreaAutoSize
            label="ภาษาไทย"
            name="expectationDescriptionTh"
            inputProps={{
              placeholder: 'กรุณาระบุความคาดหวังของผู้มีส่วนได้เสีย (ไทย)',
              minRows: 3,
              readOnly: isCompletedTh,
              tabIndex: isCompletedTh ? -1 : undefined,
            }}
            sx={isCompletedTh ? disabledTextAreaInputStyles : {}}
            flex={1}
            minWidth={200}
          />
          <FormTextAreaAutoSize
            label="ภาษาอังกฤษ"
            name="expectationDescriptionEn"
            inputProps={{
              placeholder: 'กรุณาระบุความคาดหวังของผู้มีส่วนได้เสีย (อังกฤษ)',
              minRows: 3,
              readOnly: isCompletedEn,
              tabIndex: isCompletedEn ? -1 : undefined,
            }}
            sx={isCompletedEn ? disabledTextAreaInputStyles : {}}
            flex={1}
            minWidth={200}
          />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default StakeholderExpectations;
